import { render } from "./ImgReport.vue?vue&type=template&id=4568fe53"
import script from "./ImgReport.vue?vue&type=script&lang=js"
export * from "./ImgReport.vue?vue&type=script&lang=js"

import "./ImgReport.vue?vue&type=style&index=0&id=4568fe53&scopped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__